import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ScrollService } from '../../splash-service';

@Component({
  selector: 'app-concept',
  templateUrl: './concept.component.html',
  styleUrls: ['./concept.component.scss']
})
export class ConceptComponent {
  constructor(
    private scrollService: ScrollService,
    private route: Router
  ) {}
  
  navigateTo(route: any[]) {
    this.route.navigate(route);
  }

  scroll(){
    this.scrollService.triggerScroll('Contact');
  }
}
